import Column from '@components/column'
import { StyleCard, StyleTag } from './style'
import Image from '@components/image'
import Typography from '@components/typography'
import Row from '@components/row'
import { FC } from 'react'
interface AppointmentPatientCardProps {
  name: string
  avatar: string
  gender: string
  age: number
  bloodGroup: string
}
const AppointmentPatientCard: FC<AppointmentPatientCardProps> = ({
  avatar,
  name,
  gender,
  age,
  bloodGroup,
}) => {
  return (
    <StyleCard>
      <Image
        fallbackType="user"
        src={`${process.env.BUCKET_URL}/${avatar}`}
        styleImage={`border-radius:50%`}
        width={40}
        height={40}
      />
      <Column rowGap={5}>
        <Typography content={name} size={14} />
        <Row colGap={10}>
          <StyleTag>{gender}</StyleTag>
          <StyleTag>{age}</StyleTag>
          <StyleTag>{bloodGroup}</StyleTag>
        </Row>
      </Column>
    </StyleCard>
  )
}

export default AppointmentPatientCard
